import classNames from "classnames/dedupe";
import React, { FC } from "react";
import InputAdornment from "../InputAdornment/InputAdornment";
import { CheckmarkSmallIcon, ExitCrossIcon } from "../../../../icons";
import { ITextInputEndAdornment } from "./ITextInputEndAdornment.interface";

/** A component that main purpose was to lower the cyclomatic complexity of TextInput's "endAdornment" property render */
const TextInputEndAdornment: FC<ITextInputEndAdornment> = ({
  adornment,
  injectedProps,
  disabled,
  dirty,
  validity,
  classes,
}) => {
  return (
    <>
      {adornment ? adornment(injectedProps) : null}
      {!adornment && !disabled && dirty && validity === "valid" ? (
        <InputAdornment
          classes={{
            root: classNames(
              (classes?.root || classes?.successIcon) ?? "text-color-success",
            ),
          }}
          position="end"
        >
          <CheckmarkSmallIcon data-testid="TextInputAdornment__successIcon" />
        </InputAdornment>
      ) : null}
      {!adornment && !disabled && dirty && validity === "error" ? (
        <InputAdornment
          classes={{
            root: classNames(
              (classes?.root || classes?.errorIcon) ?? "text-color-error",
            ),
          }}
          position="end"
        >
          <ExitCrossIcon data-testid="TextInputAdornment__errorIcon" />
        </InputAdornment>
      ) : null}
    </>
  );
};

export default TextInputEndAdornment;
